import { Col, Form, Modal, Row } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import * as Common from '../../../utils/Common'
import api from '../../../config/AxiosInstance'
import { Formik } from 'formik'
import { BusinessUnitAddEditSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import TextField from '../../Input/TextInput'
import SelectInput from '../../Input/SelectInput'

const statuses = [
  { id: 'true', name: 'Active' },
  { id: 'false', name: 'Inactive' }
]

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

function ModalUpdateBusinessUnit(props) {
  const [selectedData, setSelectedData] = useState({
    name: '',
    status: 'true'
  })
  const [loading, setLoading] = useState(true)
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const loadData = async (id) => {
    setLoading(true)
    try {
      const response = await api.get(`master/business-units/${id}`)
      setSelectedData({
        name: response.data.data.name,
        status: response.data.data.status ? 'true' : 'false'
      })
      setLoading(false)
    } catch (err) {
      setLoading(false)
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  useEffect(() => {
    if (props.id) {
      loadData(props.id)
    }
  }, [props.id])

  const handleSubmit = async (values) => {
    try {
      setLoadingSubmit(true)
      const payload = {
        name: values.name,
        status: values.status === 'true' || values.status === true
      }
      const response = await api.post(
        `master/business-units/${props.id}`,
        payload
      )
      if (response.data.success) {
        props.onHide()
        props.refreshData()
        Common.showPopUpSuccessMessage(response.data.message)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmit(false)
    }
  }

  return (
    <Modal {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Business Unit</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <p className="text-center">Loading...</p>
        ) : (
          <Formik
            key={props.id}
            enableReinitialize={true}
            initialValues={{
              name: selectedData.name,
              status: selectedData.status
            }}
            validationSchema={BusinessUnitAddEditSchema}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={(values) => {
              handleSubmit(values)
            }}
          >
            {({
              handleBlur,
              handleSubmit,
              handleChange,
              values,
              errors,
              touched,
              isValid,
              dirty
            }) => {
              return (
                <Form className="d-grid gap-2" onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12}>
                      <TextField
                        label="Business Unit Name"
                        name="name"
                        value={values.name}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        placeholder="Input Business Unit Name"
                        required={true}
                        styles={FormControlStyle}
                      />
                    </Col>
                    <Col md={12}>
                      <SelectInput
                        label="Status"
                        name="status"
                        id="status"
                        value={values.status}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        options={statuses}
                        required={true}
                        styles={FormControlStyle}
                      />
                    </Col>
                  </Row>
                  <Modal.Footer className="mt-3">
                    <CustomCloseButton text={'Cancel'} onClick={props.onHide} />
                    <CustomButton
                      onClick={handleSubmit}
                      variant={
                        !isValid || loadingSubmit ? 'secondary' : 'primary'
                      }
                      disabled={!isValid || loadingSubmit}
                      text={loadingSubmit ? 'Saving...' : 'Save'}
                    />
                  </Modal.Footer>
                </Form>
              )
            }}
          </Formik>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ModalUpdateBusinessUnit
